import { Component, OnInit, forwardRef } from "@angular/core";
import {
  AlertController,
  IonicModule,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { ModalPessoaPage } from "../modal-pessoa/modal-pessoa.page";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { RecadastroPessoaPage } from "../recadastro/recadastro-pessoa/recadastro-pessoa.page";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

declare var instituicaoConstants: { BUSCAR_INTITUICOES: number };

@Component({
  selector: "app-buscar-pessoa",
  templateUrl: "./buscar-pessoa.page.html",
  styleUrls: ["./buscar-pessoa.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class BuscarPessoaPage implements OnInit {
  titulo: string = "";
  buscarGeral: boolean = false;
  cc: any = 0;
  filtro: any = { q: "", t: "0" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  pessoaList: any = [];
  public isControle = false;
  isVisitante: boolean = false;
  flagOracao: boolean = false;
  adiciona: boolean = false;
  showTipo: boolean = false;
  idGrupo: any;
  idOperacao: any;
  dependenteOvelhinha: any = "";
  idDependente: any = "";
  idade: any = "";
  recadastro = false;
  aba = "nome";
  loaded = false;
  pendente: boolean = true;
  notFoundText: any = "Nenhuma Pessoa Localizada.";
  exibirFiltroMembrosTodasFiliais = false;
  isOracao = false;
  isPessoasSemGrupo = '';
  isPessoasSemGrupoReuniao = '';
  idInstituicaoFiltroOvelhinha = '';
  filtrarTodasInstituicoes = [
    { id: '0', nome: this.translate.instant('Todas instituições do multi-igreja') },
    { id: '1', nome: this.translate.instant('Apenas a instituição atual') },
  ];
  filtroMapping: any = {
    'all': 'all',
    'current': 'current'
  };
  participante = false

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public pessoaProvider: PessoaProvider,
    public userProvider: UserProvider,
    private translate: TranslateService,
    public alertCtrl: AlertController,
  ) {
    this.titulo = this.navParams.get("titulo");
    this.buscarGeral = this.navParams.get("buscarGeral")
      ? this.navParams.get("buscarGeral")
      : false;
    this.isVisitante = this.navParams.get("isVisitante");
    this.flagOracao = this.navParams.get("flagOracao")
      ? this.navParams.get("flagOracao")
      : false;
    this.showTipo = this.navParams.get("showTipo");
    this.idDependente = this.navParams.get("dependenteOvelhinha");
    this.idade = this.navParams.get("idade");
    this.adiciona = this.navParams.get("adiciona");
    this.idGrupo = this.navParams.get("idGrupo");
    this.idOperacao = this.navParams.get("idOperacao");
    this.recadastro = this.navParams.get("recadastro");
    this.participante = this.navParams.get("participante");

    this.isControle = instituicaoConstants.BUSCAR_INTITUICOES == 2;
    this.exibirFiltroMembrosTodasFiliais = this.navParams.get('exibirFiltroMembrosTodasFiliais');
    this.idInstituicaoFiltroOvelhinha = this.navParams.get('idInstituicaoFiltroOvelhinha');
    this.isOracao = this.navParams.get('isOracao') ? this.navParams.get('isOracao') : false;
    this.isPessoasSemGrupo = this.navParams.get('isPessoasSemGrupo');
    this.isPessoasSemGrupoReuniao = this.navParams.get('isPessoasSemGrupoReuniao');

    if (this.exibirFiltroMembrosTodasFiliais) {
      this.filtro.filtroInstituicaoMultiIgreja = 'current';
    }

    if (this.idGrupo) {
      this.filtro.idGrupo = this.idGrupo;
    }

    if (this.participante) {
      this.filtro.participante = this.participante;
    }

    if (this.isPessoasSemGrupo) {
      this.filtro.isPessoasSemGrupo = this.isPessoasSemGrupo;
    }

    if (this.isPessoasSemGrupoReuniao) {
      this.filtro.isPessoasSemGrupoReuniao = this.isPessoasSemGrupoReuniao;
    }

    if (this.idDependente) {
      this.filtro.idDependente = this.idDependente;
    }

    if (this.idade) {
      this.filtro.idade = this.idade;
    }

    if (this.recadastro) {
      this.filtro.recadastro = true;
      this.filtro.pendente = this.pendente;

      this.pessoaProvider.getAviso("2").subscribe((result) => {
        this.notFoundText = result.texto;
      });
    }

    if (this.idOperacao) {
      this.filtro.idOperacao = this.idOperacao;
    }

    if (this.buscarGeral) {
      this.filtro.t = "2";
    }

    this.filtro.isOracao = this.isOracao;

    if (this.idInstituicaoFiltroOvelhinha) {
      if (this.userProvider.hasConfig(219)) {
        this.filtro.filtroInstituicaoMultiIgreja = 'all'
      }

      this.filtro.idInstituicaoFiltroOvelhinha = this.idInstituicaoFiltroOvelhinha;
    }

    this.aba =
      this.filtro.t === "0" || this.filtro.t === "2" ? "nome" : "identificacao";
    this.loadPessoas(null);

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  ngOnInit() { }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  loadPessoas(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };
    }

    if (!this.isVisitante) {
      this.pessoaProvider
        .getPessoas(this.filtro, this.pagination)
        .subscribe((res) => {
          if (!infiniteScroll) {
            this.pessoaList = [];
          }

          this.pessoaList = this.pessoaList.concat(res.pessoas);
          this.pagination = res.pagination;

          if (infiniteScroll) {
            infiniteScroll.target.complete();
          }
        });
    } else {
      this.pessoaProvider
        .getVisitantes(this.filtro, this.pagination)
        .subscribe((res) => {
          if (!infiniteScroll) {
            this.pessoaList = [];
          }

          this.pessoaList = this.pessoaList.concat(res.pessoas);
          this.pagination = res.pagination;

          if (infiniteScroll) infiniteScroll.target.complete();
        });
    }
  }

  async selecionar(p: { id: any }) {
    if (this.recadastro) {
      let dadosPessoa = { pessoa: p };
      const modalRecadastro = await this.modalCtrl.create({
        component: RecadastroPessoaPage,
        componentProps: dadosPessoa,
      });
      modalRecadastro.present();

      const data = await modalRecadastro.onDidDismiss();
      if (data.data.recadastro) {
        this.loadPessoas(null);
      }
    } else {
      if (
        this.flagOracao == true ||
        this.adiciona == true ||
        this.idOperacao > 0 ||
        this.buscarGeral == true ||
        this.idGrupo > 0
      ) {
        if (p) {
          this.modalCtrl.dismiss({ pessoa: p });
        }
      } else {
        if (p) {
          const modalPessoa = await this.modalCtrl.create({
            component: ModalPessoaPage,
            componentProps: { idPessoa: p.id },
          });
          modalPessoa.present();
        }
      }
    }
  }

  onInput() {
    this.loadPessoas(null);
  }

  radioChange(event: any) {
    this.filtro.q = "";
    const valor = event.detail.value;
    this.filtro.t = valor === "nome" ? "0" : Number(valor);
    if (valor === "nome" && this.buscarGeral) {
      this.filtro.t = "2";
    }

    this.pagination = { currentPage: 0, pageCount: 0 };
    this.loadPessoas(null);
  }

  pendentes(check: any) {
    this.pendente = !check ? true : false;
    this.filtro.pendente = this.pendente;
    this.loadPessoas(null);
  }

  async toggleFilter() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Filtrar por:'),
      inputs: [
        {
          value: 'all',
          label: this.translate.instant('Todas instituições do multi-igreja'),
          type: 'radio',
          checked: this.filtro.filtroInstituicaoMultiIgreja === 'all'
        },
        {
          value: 'current',
          label: this.translate.instant('Instituição atual'),
          checked: this.filtro.filtroInstituicaoMultiIgreja === 'current',
          type: 'radio',
        },
      ],
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('Confirmar'),
          handler: (data: any) => {
            this.filtro.filtroInstituicaoMultiIgreja = this.filtroMapping[data] || false;

            this.loadPessoas(null);
          },
        },
      ],
    });
    alert.present();
  }
}
